import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { SaveSuccess } from "ui/Scripts/source/models/common/saveSuccess";
import { ModifyUserItems } from "ui/Scripts/source/models/user/modifyUserItems";
import { WhistleBlowEdit } from "ui/Scripts/source/models/whistleBlow/whistleBlowEdit";
import { WhistleBlowEditSaveSuccess } from "ui/Scripts/source/models/whistleBlow/whistleBlowEditSaveSuccess";
import { WhistleBlowChannelEdit } from "ui/Scripts/source/models/whistleBlowChannel/whistleBlowChannelEdit";
import { WhistleBlowListItems } from "ui/Scripts/source/models/whistleBlow/whistleBlowListItems";
import { WhistleBlowCategoryEdit } from "ui/Scripts/source/models/whistleBlowCategory/whistleBlowCategoryEdit";
import { WhistleBlowCategoryListItems } from "ui/Scripts/source/models/whistleBlowCategory/whistleBlowCategoryListItems";
import { WhistleBlowEventLogListItems } from "ui/Scripts/source/models/whistleBlow/whistleBlowEventLogListItems";
import { WhistleBlowEditItemMessages } from "ui/Scripts/source/models/whistleBlow/whistleBlowEditItemMessages";
import { AbortDictionary, getApiCall, getFileApiCall, postApiCall } from "./tokenService";
import { WhistleBlowPage } from "../whistleBlow/whistleBlowPage";
import { UnitNodePermissions } from "../unit/unitNodePermissions";
import { UnitNodeDefaultHandlers } from "../unit/unitNodeDefaultHandlers";
import { UserListItems } from "../user/userListItems";
import { ModuleUnits } from "../unit/moduleUnits";
import { WhistleBlowPageData } from "../whistleBlow/whistleBlowPageData";
import { SaveSuccessItems } from "ui/Scripts/source/models/common/saveSuccessItems";
import { ReportItems } from "../report/reportItems";
import { ReportGenerated } from "../report/reportGenerated";
import { IReportParameterValue } from "../report/reportParameterValue";
import { IPagePanel } from "../common/pagePanel";
import { ISavedChartPanel } from "../chart/savedChartPanel";
import { UserGroupUserSaveSuccess } from "../userGroup/userGroupEditUserSaveSuccess";
import { FrontToDoItems } from "../front/frontToDoItems";
import { UnitModuleSaveResult } from "../unit/unitModuleSaveResult";
import { DashboardChartData } from "../report/dashboardChartData";

//Abort
const commonAborts = new AbortDictionary();
const reportAborts = new AbortDictionary();
const chartAborts = new AbortDictionary();
const statisticAborts = new AbortDictionary();

// #region WhistleBlowPage
export const getWhistleBlowPage = (): Promise<WhistleBlowPage> => {
    return getApiCall("api/whistleblow", WhistleBlowPage);
};

export const getWhistleBlowPageData = (companyId: string): Promise<WhistleBlowPageData> => {
    return getApiCall("api/whistleblow/pagedata?id=" + companyId, WhistleBlowPageData);
};

export const getWhistleBlowListItems = (companyId: string, pageSize: number, page: number, filter: string, startDate: number, endDate: number, unitIds: string[], categoryIds: string[], handlerUserCodes: string[],
    state: number, severity: number, resolution: number, source: number, anonymity: number, dynamicTime: number, sortColumn: string, sortOrderIsAsc: boolean): Promise<WhistleBlowListItems> => {
    reportAborts.abortAll();
    chartAborts.abortAll();
    statisticAborts.abortAll();
    return postApiCall("api/whistleblow/list", WhistleBlowListItems, JSON.stringify({
        companyId,
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        startDate,
        endDate,
        filter: filter || "",
        unitIds,
        categoryIds,
        handlerUserCodes,
        state,
        severity,
        resolution,
        source,
        anonymity,
        dynamicTime
    }));
};
// #endregion WhistleBlowPage

// #region Edit
export const getWhistleBlowEdit = (id: string): Promise<WhistleBlowEdit> => {
    return getApiCall("api/whistleblow/edit?id=" + id, WhistleBlowEdit);
};

export const saveWhistleBlowEdit = (data: any): Promise<WhistleBlowEditSaveSuccess> => {
    return postApiCall("api/whistleblow/editsave", WhistleBlowEditSaveSuccess, JSON.stringify(data));
};

export const saveWhistleBlowDescriptionEdit = (data: any): Promise<SaveSuccess> => {
    return postApiCall("api/whistleblow/editsavedescription", SaveSuccess, JSON.stringify(data));
};

export const saveWhistleBlowNew = (data: any): Promise<SaveSuccess> => {
    return postApiCall("api/whistleblow/newsave", SaveSuccess, JSON.stringify(data));
};

export const removeWhistleBlow = (id: string): Promise<ApiSuccess> => {
    return postApiCall("api/whistleblow/remove?id=" + id, ApiSuccess);
};

export const getDefaultWhistleBlowHandlersForUnit = (unitId: string): Promise<ModifyUserItems> => {
    return getApiCall("api/whistleblow/unitdefaulthandlers?id=" + unitId, ModifyUserItems);
};

export const getWhistleblowPrint = (id: string): Promise<string> => {
    return getFileApiCall("api/whistleblow/print?id=" + id);
};
// #endregion Edit

// #region Edit Attachment
export const whistleBlowEditRemoveAttachments = (data: any): Promise<ApiSuccess> => {
    return postApiCall("api/whistleblow/editremoveattachments", ApiSuccess, JSON.stringify(data));
};

export const whistleBlowEditAddAttachments = (data: any): Promise<SaveSuccessItems> => {
    return postApiCall("api/whistleblow/editaddattachments", SaveSuccessItems, JSON.stringify(data));
};
// #endregion Edit Attachment

// #region Edit Message
export const whistleBlowEditAddMessage = (data: any): Promise<SaveSuccess> => {
    return postApiCall("api/whistleblow/editaddmessage", SaveSuccess, JSON.stringify(data));
};

export const sendWhistleBlowMessageReadReceipts = (whistleBlowId: string, ids: string[], internalMessage: boolean): Promise<ApiSuccess> => {
    return postApiCall("api/whistleblow/sendreadreceipts", ApiSuccess, JSON.stringify({
        whistleBlowId,
        ids,
        internalMessage
    }));
};

export const getWhistleBlowMessages = (id: string): Promise<WhistleBlowEditItemMessages> => {
    return getApiCall("api/whistleblow/listmessages?id=" + id, WhistleBlowEditItemMessages);
};
// #endregion Edit Message

// #region Edit Handler
export const getHandlersSelectUserListItems = (whistleBlowId: string, unitId: string, pageSize: number, page: number, filter: string,
    ignoreUserIds: string[], ignoreUserCodes: string[], activityState: number, ignoreRecordUserConnected: boolean, doNotIgnoreRecordUserConnectedUserCode: string,
    sortColumn: string, sortOrderIsAsc: boolean): Promise<UserListItems> => {
    return postApiCall("api/whistleblow/selecthandlers", UserListItems, JSON.stringify({
        whistleBlowId,
        unitId,
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || "",
        ignoreUserIds,
        ignoreUserCodes,
        ignoreRecordUserConnected,
        doNotIgnoreRecordUserConnectedUserCode,
        activityState
    }));
};

export const whistleBlowEditAddHandlers = (whistleBlowId: string, userCodes: string[]): Promise<ApiSuccess> => {
    return postApiCall("api/whistleblow/editaddhandlers", ApiSuccess, JSON.stringify({
        whistleBlowId,
        userCodes
    }));
};

export const whistleBlowEditRemoveHandlers = (whistleBlowId: string, userCodes: string[]): Promise<ApiSuccess> => {
    return postApiCall("api/whistleblow/editremovehandlers", ApiSuccess, JSON.stringify({
        whistleBlowId,
        userCodes
    }));
};
// #endregion Edit Handler

// #region Edit EventLog
export const getWhistleBlowEventLogListItems = (whistleBlowId: string, pageSize: number, page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean): Promise<WhistleBlowEventLogListItems> => {
    return postApiCall("api/whistlebloweventLog/list", WhistleBlowEventLogListItems, JSON.stringify({
        whistleBlowId,
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || ""
    }));
};
// #endregion Edit EventLog

// #region Archiving
export const archiveWhistleBlows = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/whistleblow/archive", SaveSuccess, JSON.stringify(obj));
};

// #endregion Archiving

// #region Module WhistleBlowChannel
export const getWhistleBlowChannelEdit = (companyId: string): Promise<WhistleBlowChannelEdit> => {
    return getApiCall("api/whistleblowchannel/edit?id=" + companyId, WhistleBlowChannelEdit);
};

export const saveWhistleBlowChannelEdit = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/whistleblowchannel/save", SaveSuccess, JSON.stringify(obj));
};

export const whistleChannelRemoveAdmins = (obj: any): Promise<UserGroupUserSaveSuccess> => {
    return postApiCall("api/whistleblowchannel/editremoveadmins", UserGroupUserSaveSuccess, JSON.stringify(obj));
};

export const whistleChannelAddAdmins = (obj: any): Promise<UserGroupUserSaveSuccess> => {
    return postApiCall("api/whistleblowchannel/editaddadmins", UserGroupUserSaveSuccess, JSON.stringify(obj));
};
// #endregion Module WhistleBlowChannel

// #region Module Permissions
export const getUnitNodePermissions = (companyId: string): Promise<UnitNodePermissions> => {
    return getApiCall("api/whistleblow/module/permissions?id=" + companyId, UnitNodePermissions);
};

export const saveUnitNodePermissions = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/whistleblow/module/savepermissions", ApiSuccess, JSON.stringify(obj));
};
// #endregion Module Permissions

// #region Module units
export const getUnits = (companyId: string): Promise<ModuleUnits> => {
    return getApiCall("api/whistleblow/module/units?id=" + companyId, ModuleUnits);
};

export const saveUnits = (obj: any): Promise<UnitModuleSaveResult> => {
    return postApiCall("api/whistleblow/module/saveunits", UnitModuleSaveResult, JSON.stringify(obj));
};
// #endregion Module units

// #region DefaultHandlers
export const getUnitNodeDefaultHandlers = (companyId: string): Promise<UnitNodeDefaultHandlers> => {
    return getApiCall("api/whistleblow/module/defaulthandlers?id=" + companyId, UnitNodeDefaultHandlers);
};

export const saveUnitNodeDefaultHandlers = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/whistleblow/module/savedefaulthandlers", ApiSuccess, JSON.stringify(obj));
};

export const defaultHandlersGetSelectUserListItems = (companyId: string, unitId: string, pageSize: number, page: number, filter: string,
    ignoreUserIds: string[], ignoreUserCodes: string[], activityState: number, ignoreRecordUserConnected: boolean, doNotIgnoreRecordUserConnectedUserCode: string,
    sortColumn: string, sortOrderIsAsc: boolean): Promise<UserListItems> => {
    return postApiCall("api/whistleblow/module/defaulthandlersselectuserslist", UserListItems, JSON.stringify({
        companyId,
        unitId,
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || "",
        ignoreUserIds,
        ignoreUserCodes,
        ignoreRecordUserConnected,
        doNotIgnoreRecordUserConnectedUserCode,
        activityState
    }));
};
// #endregion DefaultHandlers

// #region Report
export const getWhistleBlowPageReportItems = (companyId: string): Promise<ReportItems> => {
    const operationId = "getWhistleBlowPageReportItems" + (companyId ?? "");
    commonAborts.abort(operationId);
    return getApiCall("api/whistleblow/reports?id=" + (companyId ?? ""), ReportItems, (id: string) => {
        commonAborts.add(operationId, id);
    }).finally(() => {
        commonAborts.remove(operationId);
    });
};

export const getReportGenerated = (reportId: string, reportName: string, startDate: number, endDate: number, unitIds: string[], categoryIds: string[], handlerUserCodes: string[],
    state: number, severity: number, resolution: number, source: number, anonymity: number, dynamicTime: number, parameterValues: IReportParameterValue[]): Promise<ReportGenerated> => {
    reportAborts.abortAll();
    chartAborts.abortAll();
    return postApiCall("api/whistleblow/createreport", ReportGenerated, JSON.stringify({
        reportId,
        reportName,
        startDate,
        endDate,
        unitIds,
        categoryIds,
        handlerUserCodes,
        state,
        severity,
        resolution,
        source,
        anonymity,
        dynamicTime,
        parameterValues
    }), (abortId: string) => {
        reportAborts.add(reportId, abortId);
    }).finally(() => {
        reportAborts.remove(reportId);
    });
};

export const getChart = (reportId: string, chartId: string, startDate: number, endDate: number, dynamicTime: number, unitIds: string[], categoryIds: string[], handlerUserCodes: string[],
    state: number, severity: number, resolution: number, source: number, anonymity: number, parameterValues: IReportParameterValue[]): Promise<DashboardChartData> => {
    const reportChartId = reportId + "#" + chartId;
    chartAborts.abort(reportChartId);
    reportAborts.abortAll();
    return postApiCall("api/whistleblow/createchart", DashboardChartData, JSON.stringify({
        reportId,
        chartId,
        startDate,
        endDate,
        dynamicTime,
        unitIds,
        categoryIds,
        handlerUserCodes,
        state,
        severity,
        resolution,
        source,
        anonymity,
        parameterValues
    }), (abortId: string) => {
        chartAborts.add(reportChartId, abortId);
    }).finally(() => {
        chartAborts.remove(reportChartId);
    });
};
// #endregion Report

// #region Dashboard
export const saveWhistleBlowPanels = (panels: IPagePanel[]): Promise<ApiSuccess> => {
    return postApiCall("api/whistleblow/savepanels", ApiSuccess, JSON.stringify({ panels }));
};

export const saveWhistleBlowChartPanels = (panels: ISavedChartPanel[]): Promise<ApiSuccess> => {
    return postApiCall("api/whistleblow/savechartpanels", ApiSuccess, JSON.stringify({ panels }));
};

export const getWhistleBlowToDoItems = (): Promise<FrontToDoItems> => {
    const operationId = "getWhistleBlowToDoItems";
    statisticAborts.abort(operationId);
    return getApiCall("api/whistleblow/todoitems", FrontToDoItems, (id: string) => {
        statisticAborts.add(operationId, id);
    }).finally(() => {
        statisticAborts.remove(operationId);
    });
};
// #endregion Dashboard

// #region Module WhistleBlowCategories
export const getWhistleBlowCategoryListItems = (companyId: string, pageSize: number, page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean): Promise<WhistleBlowCategoryListItems> => {
    return postApiCall("api/whistleblow/module/category/list", WhistleBlowCategoryListItems, JSON.stringify({
        companyId,
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || ""
    }));
};

export const getWhistleBlowCategoryEdit = (companyId: string, whistleBlowCategoryId: string): Promise<WhistleBlowCategoryEdit> => {
    return getApiCall("api/whistleblow/module/category/edit?id=" + whistleBlowCategoryId + "&companyId=" + companyId, WhistleBlowCategoryEdit);
};

export const saveWhistleBlowCategoryEdit = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/whistleblow/module/category/save", SaveSuccess, JSON.stringify(obj));
};

export const removeWhistleBlowCategories = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/whistleblow/module/category/remove", ApiSuccess, JSON.stringify(obj));
};
// #endregion Module WhistleBlowCategories
